import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosApi } from "../../helpers/AxiosApi";
import initialStates from "./state";

// Get Technician List
export const getTechnicianList = createAsyncThunk(
  "getTechnicianList",
  async (
    {
      search,
      status,
      pageLimit,
      pageCount,
      type,
      company_name,
      sort_by,
      sort_direction,
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.get(
        `technicians?type=${type}&sort_by=${sort_by}&sort_direction=${sort_direction}&status=${status}&company_name=${company_name}&search=${search}&page=${pageCount}&limit=${pageLimit}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

//Get Company List
export const getcompanyList = createAsyncThunk(
  "getcompanyList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get("tech-companies");
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Get Technician
export const getTechnician = createAsyncThunk(
  "getTechnician",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`/technicians/${id}`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Create Edit Technician
export const createTechnicians = createAsyncThunk(
  "createTechnicians",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`technicians`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// create Reset pin
export const resetPin = createAsyncThunk(
  "resetPin",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`technicians/reset-pin`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// update Technician Status
export const updateTechnicianStatus = createAsyncThunk(
  "updateTechnicianStatus",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`technicians/${id}`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Delete Technician
export const deleteTechnician = createAsyncThunk(
  "deleteTechnician",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`/technicians/${id}`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Get Technician Earning List
export const getTechnicianEarningList = createAsyncThunk(
  "getTechnicianEarningList",
  async (
    {
      search,
      status,
      pageLimit,
      pageCount,
      sort_by,
      sort_direction,
      date_range,
      role,
      payment_status,
      modified_by,
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.get(
        `technicians-earnings?&role=${role}&payment_status=${payment_status}&modified_by=${modified_by}&sort_by=${sort_by}&sort_direction=${sort_direction}&status=${status}&search=${search}&page=${pageCount}&limit=${pageLimit}&date_range=${date_range}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// update Technician Status
export const updateTechnicianEarningStatus = createAsyncThunk(
  "updateTechnicianEarningStatus",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`technicians-earnings/update`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Delete Technician
export const deleteTechnicianEarning = createAsyncThunk(
  "deleteTechnicianEarning",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`/technicians-earnings/${id}`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

const technicianSlice = createSlice({
  name: "technicians",
  initialState: initialStates,
  extraReducers: (builder) => {
    builder
      // get Technician List
      .addCase(getTechnicianList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTechnicianList.fulfilled, (state, action) => {
        state.loading = false;
        state.getTechnicianListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getTechnicianList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // get Technician Earning List
      .addCase(getTechnicianEarningList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTechnicianEarningList.fulfilled, (state, action) => {
        state.loading = false;
        state.getTechnicianEarningListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getTechnicianEarningList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Get Technician
      .addCase(getTechnician.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTechnician.fulfilled, (state, action) => {
        state.loading = false;
        state.getTechnicianStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getTechnician.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Get Company List
      .addCase(getcompanyList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getcompanyList.fulfilled, (state, action) => {
        state.loading = false;
        state.getcompanyListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getcompanyList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Create Edit Technician
      .addCase(createTechnicians.pending, (state) => {
        state.loading = true;
      })
      .addCase(createTechnicians.fulfilled, (state, action) => {
        state.loading = false;
        state.createTechniciansStatus.data = action.payload;
        state.error = false;
      })
      .addCase(createTechnicians.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Create Reset Pin
      .addCase(resetPin.pending, (state) => {
        state.loading = true;
      })
      .addCase(resetPin.fulfilled, (state, action) => {
        state.loading = false;
        state.resetPinStatus.data = action.payload;
        state.error = false;
      })
      .addCase(resetPin.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Delete Technician
      .addCase(deleteTechnician.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteTechnician.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteTechnicianStatus.data = action.payload;
        state.error = false;
      })
      .addCase(deleteTechnician.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Delete Technician Earning
      .addCase(deleteTechnicianEarning.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteTechnicianEarning.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteTechnicianEarningStatus.data = action.payload;
        state.error = false;
      })
      .addCase(deleteTechnicianEarning.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // update Technician Status
      .addCase(updateTechnicianStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateTechnicianStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.updateTechnicianStatusStatus.data = action.payload;
        state.error = false;
      })
      .addCase(updateTechnicianStatus.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // update Technician earning Status
      .addCase(updateTechnicianEarningStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateTechnicianEarningStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.updateTechnicianEarningStatusStatus.data = action.payload;
        state.error = false;
      })
      .addCase(updateTechnicianEarningStatus.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});
const { reducer } = technicianSlice;
export default reducer;
